(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.factory('AgendaTransitionService', [
        '$rootScope',
        '$q',
        '$state',
        '$localStorage',
        '$stateParams',
        '$uibModalStack',
        'SharedAgendaBroadcast',
        'ProtocolBroadcastService',
        'ProtocolFilter',
        'SharedAgendaService',
        'DateService',
        'AdministrationService',
        'AuthenticationService',
        'ViewsService',
        AgendaTransitionServiceFn,
    ]);

    /* Main Service for Switching/Changing/Selecting Shared Agendas */
    function AgendaTransitionServiceFn(
        $rootScope,
        $q,
        $state,
        $localStorage,
        $stateParams,
        $uibModalStack,
        SharedAgendaBroadcast,
        ProtocolBroadcastService,
        ProtocolFilter,
        SharedAgendaService,
        DateService,
        AdministrationService,
        AuthenticationService,
        ViewsService
    ) {
        var service = {
            select: select,
            change: change,
            toContacts: toContacts
        };

        return service;

        // select/switch to the new shared agenda
        function select(agenda) {
            change(agenda.owner.id, undefined, true);
        } // select
        
        function toContacts(userId) {
            let deferred = $q.defer();
            let promise = SharedAgendaService.isLoading();
            promise.then(function () {
                // close all modals
                $uibModalStack.dismissAll();
                // first load the shared-agendas of the selected user
                return SharedAgendaService.loadAgendasByUser(userId)
                    .then(function (result) {
                        // if RP operator: load the view of the current agenda owner 
                        if ($rootScope.isRingfoon) {
                            inform(SharedAgendaService.data.currentAgenda, true);
                            $state.go('Home.Users', undefined, {reload: 'Home.Users'});
                            return deferred.resolve(true);
                        }
                    });
            });

            return promise;
        }

        // change agenda
        function change(userId, toDate, currentState) {
            var deferred = $q.defer();

            // go always to agenda-per-day view
            var today = true;
            if (toDate) {
                // set new date
                DateService.dateAndBroadcast(moment(toDate).toDate());
                today = false;
            } // if

            var promise = SharedAgendaService.isLoading();

            promise.then(function () {
                // only switch if the current-shared-agenda-user is different
                if (SharedAgendaService.currentUser().id === userId) {
                    reloadCurrentState(currentState, today);
                    deferred.resolve(true);
                    return deferred.promise;
                }

                // close all modals
                $uibModalStack.dismissAll();
                // first load the shared-agendas of the selected user
                return SharedAgendaService.loadAgendasByUser(userId)
                    .then(function (result) {

                        // if RP operator: load the view of the current agenda owner 
                        if ($rootScope.isRingfoon) {
                            ViewsService.getViewsForOwner(SharedAgendaService.currentUser().id)
                                .then(function () {
                                    inform(SharedAgendaService.data.currentAgenda, true);
                                    reloadCurrentState(currentState, today);
                                    return deferred.resolve(true);
                                });

                        } // else {
                        //   reloadCurrentState(currentState, today);
                        // } 
                    });
            });

            return promise;
        } // change

        function reloadCurrentState(currentState, today) {

            if (currentState) {
                $state.go($state.current, $stateParams, {reload: $state.current});
            } else {
                $state.go(
                    'Home.Agenda_Day',
                    {today: today, agendaOwnerId: null, phoneNumber: null},
                    {reload: $state.current}
                );
            }
        }

        // inform listeners
        function inform(agenda, showProtocolOnLoad) {
            if (
                !agenda ||
                typeof agenda.owner === 'undefined' ||
                agenda.owner === null
            ) {
                return;
            }
            // also load complete data (only if Ringfoon)
            if ($rootScope.isRingfoon) {
                // load complete data
                SharedAgendaService.loadOwner(agenda.owner.id).then(function () {
                    // show protocols
                    if (showProtocolOnLoad) {
                        // show start-protocol
                        ProtocolBroadcastService.broadcast(ProtocolFilter.ShowAlwaysOnLoad);
                    } else {
                        ProtocolBroadcastService.broadcast(
                            ProtocolFilter.ShowOnAgendaChange
                        );
                    }

                    $rootScope.$broadcast(SharedAgendaBroadcast.AgendaOwnerChanged);

                    // UPDATE, We don't change language for Ringphone Operators, we only show a warning in header
                    // refresh api_token if needed (language if different)
                    //changeLanguage(agenda);
                    
                    $rootScope.$broadcast(SharedAgendaBroadcast.AgendaChanged);
                });
            } //if
            else {
                // broadcast that shared client changed
                $rootScope.$broadcast(SharedAgendaBroadcast.AgendaChanged);
                $rootScope.$broadcast(SharedAgendaBroadcast.UpdateUI);
            } // else
        } // inform

        // change language if different
        function changeLanguage(agenda) {
            // refresh api_token if needed (language is different)
            if (agenda.owner.languageId !== $localStorage.CurrentLanguage.id) {
                AdministrationService.refreshToken(agenda.owner.languageId).then(
                    function (result) {
                        // set new Authentication Header
                        AuthenticationService.setAuthenticationHeader(result.api_token);
                        // set new Language
                        AdministrationService.setLanguage(result.language);
                        // broadcast that shared client changed
                        $rootScope.$broadcast(SharedAgendaBroadcast.AgendaChanged);
                    }
                );
            } // if
            else {
                // broadcast that shared client changed
                $rootScope.$broadcast(SharedAgendaBroadcast.AgendaChanged);
            } // else
        } // changeLanguage
    }
})();
